export default {
    getUrlByState() {
        const data = {
            'loc':  'http://localhost:8080/',
            'dev':  'http://agent.theeurasia.kz/',
            'prod': 'https://eagent.kz/'
        }
        return data[process.env.VUE_APP_STATE]
    },
    getBackEndUrlByState() {
        const data = {
            'loc':  'http://api.agent.loc/',
            'dev':  'http://api.agent.theeurasia.kz/',
            'prod': 'https://api.eagent.kz/'
        }
        return data[process.env.VUE_APP_STATE]
    }
}